export default __webpack_public_path__ + "static/media/publique2.d38e848f.png";